import Cookies from 'js-cookie'
import UUID from 'uuid/v4'

export default class deviceInfo {
  getConfig = () => {
    let config = null;
    if(navigator){
      let navi = navigator;
      let plugStrs = this.getPlugins(navi);
      config = {
        'Gov-Client-Connection-Method': 'WEB_APP_VIA_SERVER',
        'Gov-Client-Browser-Do-Not-Track': (~['1', 'on', undefined].indexOf(navigator.doNotTrack)) && 1 ? true : false,
        'Gov-Client-Browser-JS-User-Agent': navi.userAgent,
        'Gov-Client-Browser-Plugins': plugStrs,
        'Gov-Client-Device-ID': this.uuid(),
        'Gov-Client-Local-IPs-Timestamp': new Date().toISOString(),
        'Gov-Client-Multi-Factor': null,
        'Gov-Client-Public-IP': null,
        'Gov-Client-Public-IP-Timestamp': null,
        'Gov-Client-Public-Port': null,
        'Gov-Client-Screens': this.getScreens(),
        'Gov-Client-Timezone': this.getTimeZone(),
        'Gov-Client-User-IDs': null,
        'Gov-Client-Window-Size': `width=${document.body.clientWidth}&height=${document.body.clientHeight}`,
        'Gov-Vendor-Forwarded': null,
        'Gov-Vendor-License-IDs': null,
        'Gov-Vendor-Product-Name': null,
        'Gov-Vendor-Public-IP': null,
        'Gov-Vendor-Version': null,
      }
    }
    return config;
  }
  getTimeZone = () => {
    let timeZone = new Date().getTimezoneOffset();
    let h = Math.abs(parseInt(timeZone / 60));
    let m = Math.abs(timeZone % 60);
    return `UTC${timeZone < 0?'-':''}${h>9?h:'0'+h}:${m>9?m:'0'+m}`;
  }
  getScreens = () => {
    let ratio = 0,
    screen = window.screen,
    ua = navigator.userAgent.toLowerCase();
    if (window.devicePixelRatio !== undefined) {
      ratio = window.devicePixelRatio;
    } else if (~ua.indexOf('msie')) {
      if (screen.deviceXDPI && screen.logicalXDPI) {
        ratio = screen.deviceXDPI / screen.logicalXDPI;
      }
    } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
      ratio = window.outerWidth / window.innerWidth;
    }
    return `width=${window.screen.width}&height=${window.screen.height}&scaling-factor=${ratio}&colour-depth=${window.screen.colorDepth}`;
  }
  getPlugins = navi =>{
    //获取插件列表
    let plugins = navi.plugins;
    let plugStrs = [];
    for(let i = 0; i < plugins.length; i++){
      plugStrs.push(plugins[i].name);
    }
    plugStrs = encodeURI(plugStrs.join(','));
    return plugStrs;
  }
  uuid = () => {
    if(Cookies.get('Gov-Client-Device-ID'))
      return Cookies.get('Gov-Client-Device-ID');
    let result = UUID();
    Cookies.set('Gov-Client-Device-ID', result);
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/utils/deviceInfo.js